import { combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import * as types from "../actions/actionTypes";
import teachers from "./teachersReducer";
import clients from "./clientsReducer";
import people from "./peopleReducer";
import products from "./productsReducer";
import enrollments from "./enrollmentsReducer";
import students from "./studentsReducer";
import schoolClasses from "./schoolClassesReducer";
import classStudents from "./classStudentsReducer";
import clientLedger from "./clientLedgerReducer";
import clientBillingView from './clientBillingViewReducer';
import books from "./booksReducer";
import settings from "./settingsReducer";
import user from "./userReducer";
import apiCallsInProgress from "./apiStatusReducer";
import lessonRegister from "./lessonRegisterReducer";
import initialState from "./initialState";

const schoolScopedStateKeys = [
  "teachers",
  "clients",
  "people",
  "products",
  "enrollments",
  "students",
  "schoolClasses",
  "classStudents",
  "clientLedger",
  "clientBillingView",
  "lessonRegister",
  "books",
  "settings",
];

const appReducer = history => combineReducers({
  router: connectRouter(history),
  teachers,
  clients,
  people,
  products,
  enrollments,
  students,
  schoolClasses,
  classStudents,
  clientLedger,
  clientBillingView,
  lessonRegister,
  books,
  user,
  settings,
  apiCallsInProgress,
});

const hasContextChanged = (currentUser = {}, nextUser = {}) => (
  (currentUser.id || null) !== (nextUser.id || null) ||
  (currentUser.activeContextKey || null) !== (nextUser.activeContextKey || null) ||
  (currentUser.schoolId || null) !== (nextUser.schoolId || null)
);

const clearSchoolScopedState = state => schoolScopedStateKeys.reduce((nextState, key) => ({
  ...nextState,
  [key]: initialState[key],
}), state);

const rootReducer = (history) => {
  const reduceApp = appReducer(history);

  return (state, action) => {
    if (state && action.type === types.SIGN_IN_SUCCESS && hasContextChanged(state.user, action.user)) {
      return reduceApp(clearSchoolScopedState(state), action);
    }

    if (state && action.type === types.SIGN_OUT) {
      return reduceApp(clearSchoolScopedState(state), action);
    }

    return reduceApp(state, action);
  };
};

export default rootReducer;
